import { tv, VariantProps } from "@/utils";

export const label = tv({
  slots: {
    base: [],
  },
  variants: {
    color: {
      dark: {
        base: ["text-primary-100"],
      },
      light: {
        base: ["text-gray-400"],
      },
    },
    hidden: {
      true: {
        base: ["hidden"],
      },
    },
  },
  defaultVariants: {
    hidden: false,
  },
});

export type LabelVariantProps = VariantProps<typeof label>;

export type LabelReturnVariantProps = ReturnType<typeof label>;
